namespace TabAurous.Common {
    export interface VoucherPostingForm {
        PartyId: Serenity.LookupEditor;
        Vouchers: VoucherPostingEditor;
    }

    export class VoucherPostingForm extends Serenity.PrefixedContext {
        static formKey = 'Common.VoucherPosting';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!VoucherPostingForm.init)  {
                VoucherPostingForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = VoucherPostingEditor;

                Q.initFormType(VoucherPostingForm, [
                    'PartyId', w0,
                    'Vouchers', w1
                ]);
            }
        }
    }
}
